var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"watermark-container"},_vm._l((_vm.totalWatermarks),function(index){return _c('div',{key:index,staticClass:"watermark-text",style:({
      top: _vm.calculateTop(index),
      left: _vm.calculateLeft(index),
      transform: 'rotate(-20deg)',
    })},[_vm._v("\n    "+_vm._s(_vm.watermarkText)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3c5b734","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/waterMark/waterMark.vue
// module id = null
// module chunks = 